import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dataOrThrow, type PostNoteBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Creates a note for a patient and invalidates relevant caches. */
export function useCreateNote() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: PostNoteBody) => {
      // Keeps the error name: the consultation workspace treats a ConflictError as already added.
      return dataOrThrow(await api.post('/notes', { body: input })).note
    },
    onSuccess: (note) => {
      queryClient.invalidateQueries({ queryKey: ['patient-timeline', note.patientId] })
      // A note can carry file attachments, which surface in the patient files box — only
      // refresh it when the created note actually has files.
      if (note.files.length > 0) {
        queryClient.invalidateQueries({ queryKey: ['patient-files', note.patientId] })
      }
      if (note.consultationId) {
        queryClient.invalidateQueries({ queryKey: ['consultation', note.consultationId] })
      }
    },
  })
}
